export function buildDynamicLabel(name: string, id?: number | string): string {
    return `${name}--${id}`;
}
export function buildDropdownOption(name: string, option?: number | string): string {
    return `${name}-${option}`;
}

export function replaceVariableOnStringChain(chain:string, value:number | string):string {
    return chain.replace(/\${([^}]*)}/g, value.toString())
}
